import React from "react"
import { MenuDivider } from "@chakra-ui/react"
import { useSelection } from "components/CanvasEditor/Editor"
import { EditorContextMenu, EditorContextMenuItem } from "components/CanvasEditor/EditorContextMenu"
import { useBadgeElement } from "../contexts/BadgeElementContext"

type Props = {
  elementId: string
  x: number
  y: number
  onClose: () => void
}

/**
 * An element's right-click menu. It acts on the whole selection when the element is part of it,
 * on the element alone otherwise.
 */
const BadgeElementContextMenu = ({
  elementId, x, y, onClose,
}: Props) => {
  const inSelection = useSelection((state) => state.selectedIds.includes(elementId))
  const selectedCount = useSelection((state) => (inSelection ? state.selectedIds.length : 1))
  const {
    duplicateSelectedOrById, deleteSelectedElements, deleteElementById, bringSelectedForward,
    sendSelectedBackward, bringToFront, sendToBack,
  } = useBadgeElement()
  const own = inSelection ? undefined : [elementId]
  const isMultiSelect = selectedCount > 1

  const item = (action: () => void) => () => {
    onClose()
    action()
  }

  return (
    <EditorContextMenu x={x} y={y} isOpen onClose={onClose}>
      <EditorContextMenuItem
        shortcut="⌘ D"
        onClick={item(() => duplicateSelectedOrById(inSelection ? undefined : elementId))}
      >
        {isMultiSelect ? `Duplicate ${selectedCount} Items` : "Duplicate"}
      </EditorContextMenuItem>
      <EditorContextMenuItem
        shortcut="⌫"
        color="red.500"
        _hover={{ bg: "red.50", color: "red.600" }}
        onClick={item(() => (
          inSelection ? deleteSelectedElements() : deleteElementById(elementId)
        ))}
      >
        {isMultiSelect ? `Delete ${selectedCount} Items` : "Delete"}
      </EditorContextMenuItem>
      <MenuDivider />
      <EditorContextMenuItem shortcut="⌘ ]" onClick={item(() => bringSelectedForward(elementId))}>
        Bring Forward
      </EditorContextMenuItem>
      <EditorContextMenuItem shortcut="⌘ [" onClick={item(() => sendSelectedBackward(elementId))}>
        Send Backward
      </EditorContextMenuItem>
      <EditorContextMenuItem shortcut="⇧⌘ ]" onClick={item(() => bringToFront(own))}>
        Bring to Front
      </EditorContextMenuItem>
      <EditorContextMenuItem shortcut="⇧⌘ [" onClick={item(() => sendToBack(own))}>
        Send to Back
      </EditorContextMenuItem>
    </EditorContextMenu>
  )
}

export default BadgeElementContextMenu
